import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { constants } from '../../../config';
import { AppLink, routeNaming } from '../../../routes';
import styles from './InformationMenu.css';

const IPropTypes = {
  indexSelectedItem: PropTypes.number,
  className: PropTypes.string,
};

const defaultProps = {
  indexSelectedItem: null,
  className: '',
};

const menuItems = (
  [
    { name: 'Ayuda', routeName: routeNaming.HELP },
    { name: 'Contacto', routeName: routeNaming.CONTACT },
    { name: 'Envíos', routeName: routeNaming.SHIPPING },
    { name: 'Locales y horarios', routeName: routeNaming.VENUES_AND_OPEN_HOURS },
    { name: 'Quienes somos', routeName: routeNaming.ABOUT_US },
    { name: 'Seguimiento de servicios', routeName: routeNaming.SERVICE_TRACKING },
    { name: `Servicio ${constants.panavoxLigature}`, routeName: routeNaming.PANAVOX_SERVICE },
    { name: 'Servicio Bronx', routeName: routeNaming.BRAND_SERVICE },
    { name: 'Términos y condiciones', routeName: routeNaming.CONDITIONS },
    { name: 'Unirse a nuestro equipo', routeName: routeNaming.JOIN_OUR_TEAM },
    { name: 'Verificar comprobante', href: constants.ticketVerificationURL },
  ]
);

const InformationMenu = ({ indexSelectedItem, className }) => (
  <div className={[styles.content, className].join(' ')}>
    <h1 className={styles.title}>Información</h1>
    <div className={styles.menu}>
      {menuItems.map((item, index) => {
        const isSelected = indexSelectedItem === index;
        if (item.routeName) {
          return (
            <AppLink
              className={isSelected ? styles.menuItemSelected : styles.menuItem}
              routeName={item.routeName}
              key={item.name}
            >
              {item.name}
            </AppLink>
          );
        }
        return (
          <a
            className={styles.menuItem}
            href={item.href}
            rel="noreferrer noopener"
            key={item.name}
            target="_blank"
          >
            {item.name}
          </a>
        );
      })}
    </div>
  </div>
);

InformationMenu.propTypes = IPropTypes;
InformationMenu.defaultProps = defaultProps;

const ObservedInformationMenu = observer(InformationMenu);

export { ObservedInformationMenu as InformationMenu };



// WEBPACK FOOTER //
// ./src/pages/information/information-menu/InformationMenu.jsx